var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClassy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1336 1520",
    width: 1280,
    height: 1280,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    transform: "translate(0)",
    d: "m0 0h1336v1520h-1336z",
    fill: "#FEFEFE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(0)",
    d: "m0 0h1336v188h-8l-1-111-111-1v81l-2 13-3 6-5 5-8 5-8 2-29 1-1 29-4 13-4 5-5 4-7 3-5 1h-31v-33l4-11 9-8 9-4 33-1v-54h-54l-1 29-4 13-8 8-8 4-4 1-31 1-1 28-3 12-7 9-10 5-6 1h-30l-1-55-55-1v138l-2 12-3 6-7 7-8 4-5 1-30 1-1 28-2 9-5 8-7 6-6 3-5 1h-367v136l-1 11-4 9-7 7-8 4-5 1-30 1-1 28-2 9-3 6-7 7-9 4-6 1h-29v83l-2 11-4 8-7 6-7 3-5 1h-31v-56h-56v-31l2-9 4-6 7-6 8-4 90-1v-54h-110l-1 28-2 9-3 6-7 7-9 4-5 1h-27l-2 1-1 28-2 9-5 8-7 6-6 3-6 1h-30v56h55l1 5v79l-2 11-6 9-9 6-7 2-31 1-1 29-2 9-5 8-6 5-6 3-6 1h-87v56h167l1 1v82l-2 11-3 6-5 5-8 5-8 2-29 1-1 29-4 13-5 6-6 4-10 3h-31v-33l3-9 5-7 10-6 4-1 33-1 1-55h-112v29l-2 10-6 9-9 6-7 2h-16z",
    fill: "#201D1F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(0)",
    d: "m0 0h376v20h56v55l-1 1-90 1-11 6-6 7-3 8-1 33-2 1-33 1-10 5-7 8-3 8-1 90h55l1 1v55l86-1 8-2 6-3 7-7 3-8 1-6 1-29h56v55l-1 1-33 1-12 6-6 7-3 8-1 33-1 1-33 1-10 4-3 3h-2l-5 10-1 5-1 32-1 1-33 1-10 5-6 5-4 8-1 3-1 33-1 1-33 1-12 6-6 7-3 8-1 33-2 1-89 1-10 5-7 8-3 8-1 33-1 1-33 1-8 3-9 8-3 6-1 5-1 33 30-1 8-2 6-3 7-8 3-7 1-6 1-28 1-1h54l1 1v54l-1 1-33 1-12 6-6 7-3 8-1 33-1 1-33 1-10 4-5 5-5 8-1 4-1 33-1 1-33 1-10 4-5 5-5 8-1 5-1 32-1 1-31 1-8 1z",
    fill: "#FEFEFE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1238,188)",
    d: "m0 0h34v168h56v224h8v168l-7 1-1 29-3 12-7 8-9 5-5 1-31 1-1 28-3 12-6 8-8 5-8 2h-31v56h56v28l-2 11-5 8-6 5-11 4h-32v85l-2 10-5 8-6 5-11 4h-32v84l-2 11-6 9-7 5-10 3h-199v-146l4-10 4-5 10-6 3-1 90-1 1-33 4-10 8-8 10-4h33l1 1v29l-2 9-5 8-6 5-11 4h-32v31l-3 11-8 9-8 4-5 1h-32v56l112-1v-33l4-10 5-5 5-4 8-3 33-1v-166l-111-1v-33l3-9 5-7 10-6 4-1 33-1 1-33 4-10 4-5 10-6 5-1h33v-33l3-9 5-7 10-6 4-1 34-1v-33l4-10 8-8 9-4 34-1 1-55h-56v29l-3 12-7 9-10 5-6 1h-86v-146l4-10 7-7 7-4 4-1h90v29l-2 10-6 9-9 6-7 2h-32v56l55-1 1-32 4-11 8-8 9-4 34-1 1-111h-112v-33l3-10 5-6 10-6 4-1 33-1v-54l-111-1v-33l3-9 4-6 9-6 5-2 35-1v-33l4-10 7-7 10-5 35-1v-33l4-9 6-7z",
    fill: "#201D1F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(565,468)",
    d: "m0 0h90l1 1v55h56v28l-2 11-5 8-6 5-6 3-5 1h-32v56h56v27l-2 12-6 9-5 4-7 3-7 1h-85v29l-2 10-4 7-7 6-6 3-7 1h-86v56h167l1 1v80l-2 13-3 6-5 5-8 5-7 2-30 1-1 29-4 13-8 8-9 4-5 1h-30v29l-2 9-5 8-7 6-11 4h-31v82l-2 12-4 8-7 6-7 3-5 1-86 1-1 28-2 10-6 9-5 4-6 3-6 1-142 1-1 28-3 12-5 7-5 4-7 3-5 1h-87v-34l4-10 7-7 10-5 35-1v-33l4-10 7-7 7-4 4-1 34-1v-33l4-9 6-7 12-6h34v56l56-1v-33l4-10 4-5 10-6 4-1 90-1v-32l3-9 7-8 12-6 33-1 1-33 4-10 7-7 11-5 33-1 1-33 4-10 4-5 10-6 4-1 33-1v-54l-167-1v139l-2 11-3 6-7 7-8 4-6 1h-86l-1-55-55-1v-90l4-10 4-5 10-6 4-1 33-1 1-32 3-9 5-7 10-6 4-1h34v56l55-1 1-200 3-9 7-8 9-5 4-1 32-1 1-31 4-11 7-8 10-5 90-1 1-55h-56v-33l3-9 5-7 10-6z",
    fill: "#201D1F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(958,692)",
    d: "m0 0h34v29l-3 12-6 8-8 5-7 2h-32v56h56v29l-2 10-4 7-7 6-6 3-5 1h-32v56h112v29l-2 10-6 9-5 4-6 3-6 1h-143v251l-2 11-4 8-7 6-7 3-6 1h-85l-1-1v-32l3-9 5-7 10-6 4-1 33-1 1-55h-56l-1-55-222-1-1-1v-31l3-10 7-8 12-6 33-1 1-33 4-9 5-6 10-6 3-1 33-1v-17l1-16 4-9 7-8 8-4 3-1h33l1 1v28l-2 10-6 9-10 6-7 2h-31l1 55h54l1-33 4-10 7-7 7-4 4-1h34v56l56-1v-33l4-10 7-7 8-4 4-1 32-1 1-111h-112v-33l3-9 5-7 10-6 4-1 89-1 1-33 4-10 7-7 11-5 33-1 1-33 4-10 7-7 7-4z",
    fill: "#201D1F"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1014,300)",
    d: "m0 0h34v112h56v83l-2 12-6 9-10 6-7 2-86 1-1 28-3 12-7 9-10 5-5 1h-143v112h56v28l-2 11-5 8-6 5-6 3-6 1h-143v-31l2-9 6-9 10-6 4-1 33-1 1-145 4-10 7-7 7-4 4-1 33-1 1-33 4-10 4-5 10-6 4-1 33-1 1-33 4-9 6-7 12-6 33-1 1-33 6-12 7-6 8-4 34-1 1-33 4-10 4-5 10-6z",
    fill: "#201D1F"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1294,1140)",
    d: "m0 0h34v87l-2 8-3 6-8 7-6 3-5 1h-32v112l56-1v-90l4-9 3-3h1v259h-232v-21l4-11 7-7 8-4 3-1 33-1 1-32 3-9 8-9 7-4 4-1 33-1v-110l-55-1v-89l4-11 7-7 7-4 4-1 90-1v-33l4-10 4-5 10-6z",
    fill: "#201D1F"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1047)",
    d: "m0 0h289v20l-211 1-10 5-5 5-4 7-1 5-1 32-2 1-32 1-10 4-5 5-5 8-1 5-1 32-2 1-89 1-10 5-7 8-3 9-1 32-1 1-90 1-11 6-6 7-3 10-1 32h56v55l-2 1-32 1-10 4-5 5-5 8-1 4-1 33-2 1h-54l-1-16v-92l1-4h-56v-56l87-1 9-3 5-3 5-5 4-8 1-9v-31l1-52h56v56l30-1 9-2 8-5 5-7 2-6 1-10v-58l1-23 87-1 8-2 8-5 4-5z",
    fill: "#FEFEFE"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(678,1252)",
    d: "m0 0h34v29l-2 9-3 6-5 5-8 5-7 2h-31v112l56-1v-89l4-10 9-8 9-4h34v212h-280v-20l3-10 7-8 8-5 3-1 34-1 1-32 3-9 7-8 8-5 4-1 33-1 1-55h-56v-32l3-10 7-8 11-6 90-1v-15l1-18 4-10 7-7z",
    fill: "#201D1F"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(544)",
    d: "m0 0h168v20l-91 1-10 5-5 5-4 7-1 5-1 33h56v167l-2 1-32 1-10 4-5 5-5 8-1 4-1 33-1 1-33 1-12 6-6 7-3 9-1 32-2 1h-54v-56l4-1h27l11-4 6-4 4-6 2-6 1-10v-29l1-52 32-1 9-3 6-4 4-5 3-7 1-7 1-29h-56l-1-19v-93z",
    fill: "#FEFEFE"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(174,188)",
    d: "m0 0h34v29l-2 10-6 9-5 4-7 3-5 1h-31v56h168v29l-2 10-4 7-7 6-6 3-7 1h-142v28l-2 10-3 6-4 5-8 5-9 2h-86v-89l3-9 5-7 10-6 4-1 33-1 1-33 4-9 6-7 12-6 33-1v-15l1-18 4-9 6-7z",
    fill: "#201D1F"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1013,1364)",
    d: "m0 0h147v28l-2 10-3 6-5 5-5 4-10 3-86 1-1 29-2 9-5 8-6 5-7 3-6 1-85 1-1 28-2 10-2 5h-108v-21l3-9 5-7 10-6 4-1 33-1 1-33 4-10 4-5 10-6 4-1 90-1v-32l4-11 4-5 10-6z",
    fill: "#201D1F"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(229,1252)",
    d: "m0 0h147v28l-2 11-4 7-7 6-6 3-6 1-86 1-1 28-3 12-7 8-8 5-8 2h-27l-2 1-1 30-3 10-4 6-6 5-7 3-5 1h-31v-33l4-11 9-8 9-4 33-1 1-89 4-10 7-7z",
    fill: "#201D1F"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(174,20)",
    d: "m0 0h34v29l-2 9-3 6-7 7-13 5h-31v84l-2 10-3 6-7 7-9 4-4 1h-31v29l-2 10-6 9-7 5-5 2-6 1h-70v-54l8-2 87-1 1-89 4-10 4-5 10-6 4-1 33-1 1-33 4-10 4-5 10-6z",
    fill: "#201D1F"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(902,1252)",
    d: "m0 0h34v56h56v29l-2 10-6 9-5 4-7 3-5 1h-143v-33l3-9 4-6 9-6 6-2 33-1 1-33 4-10 7-7 7-4z",
    fill: "#201D1F"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(510,1140)",
    d: "m0 0h34v140l-2 10-3 6-4 5-6 4-10 3h-87v-33l3-9 5-7 10-6 4-1 33-1 1-89 4-10 9-8z",
    fill: "#201D1F"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(432,76)",
    d: "m0 0h55l1 1v110l-1 1-34 1-10 5-7 8-3 9-1 32-1 1h-55v-56l32-1 11-4 5-4 4-6 2-6 1-7z",
    fill: "#FEFEFE"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(118,1308)",
    d: "m0 0h34v30l-4 13-4 5-10 6-7 2h-31v31l-3 10-5 7-10 6-7 2h-31v84l-3 14-1 2h-36v-98l8-2 32-1-1-3v-13l1-17 4-10 7-7 11-5 33-1 1-33 4-10 4-5 10-6z",
    fill: "#201D1F"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(285,1364)",
    d: "m0 0h147v29l-2 10-6 9-5 4-7 3-5 1h-142l-1-1v-31l3-10 7-8 8-5z",
    fill: "#201D1F"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(621,1140)",
    d: "m0 0h91v29l-2 10-5 8-6 5-6 3-5 1h-32v30l-2 8-4 8-7 6-7 3-5 1h-31v-90l4-10 4-5 10-6z",
    fill: "#201D1F"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(173,412)",
    d: "m0 0h91v29l-2 10-6 9-10 6-7 2h-87v29l-2 9-5 8-7 6-6 3-5 1h-30l-1-1v-32l3-9 4-6 9-6 6-2 34-1v-32l3-9 9-10z",
    fill: "#201D1F"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(376,412)",
    d: "m0 0h56v55l-1 1-34 1-10 5-7 8-3 9-1 32-2 1h-54v-56l31-1 9-3 6-4 6-7 3-12z",
    fill: "#FEFEFE"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(937,412)",
    d: "m0 0h54l1 1v54l-2 1-33 1-10 5-7 8-3 9-1 32-2 1h-53l-1-1v-55l31-1 9-3 6-4 5-6 3-7 1-6 1-28z",
    fill: "#FEFEFE"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1272,1420)",
    d: "m0 0h64v100h-64l-1-17v-78z",
    fill: "#FEFEFE"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(488,636)",
    d: "m0 0h112v56h-112z",
    fill: "#FEFEFE"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(40,804)",
    d: "m0 0h56v55l-1 1-34 1-10 5-7 8-3 10-1 31-1 1h-39v-56l16-1 10-4 8-7 4-9 1-6z",
    fill: "#FEFEFE"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(286,20)",
    d: "m0 0h34v29l-2 9-3 6-7 7-9 4-5 1h-30v30l-4 13-4 5-10 6-7 2h-30l-1-1v-33l4-9 5-6 10-6 3-1 24-1h9l1-33 4-10 7-7 7-4z",
    fill: "#201D1F"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(173,1476)",
    d: "m0 0h90l1 5v39h-112v-21l4-11 4-5 10-6z",
    fill: "#201D1F"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(36,1195)",
    d: "m0 0 4 1v85l-2 10-6 9-9 6-7 2h-16v-110l8-2z",
    fill: "#201D1F"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1294,972)",
    d: "m0 0h42v112h-8l-1-55-55-1v-32l2-8 4-7 8-6z",
    fill: "#201D1F"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(712,20)",
    d: "m0 0h55l1 1v54l-2 1h-54l-1-52z",
    fill: "#FEFEFE"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1160,804)",
    d: "m0 0h56v55l-1 1h-55z",
    fill: "#FEFEFE"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(656,300)",
    d: "m0 0h56v55l-1 1h-55z",
    fill: "#FEFEFE"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(0)",
    d: "m0 0h151l-2 5-4 6-6 5-6 3-6 1h-127z",
    fill: "#201D1F"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1014,1252)",
    d: "m0 0h33l1 1v28l-2 10-6 9-9 6-7 2h-32v-33l3-9 5-7 10-6z",
    fill: "#201D1F"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1014,580)",
    d: "m0 0h34v30l-3 12-8 9-9 4-5 1h-31v-32l3-10 7-8 8-5z",
    fill: "#201D1F"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(454,1420)",
    d: "m0 0h34v29l-3 12-6 8-7 4-4 2-6 1h-30v-32l3-10 4-6 11-7z",
    fill: "#201D1F"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(656,1476)",
    d: "m0 0h56v44h-56l-1-38z",
    fill: "#FEFEFE"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1160,1476)",
    d: "m0 0h56v44h-56z",
    fill: "#FEFEFE"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(0,524)",
    d: "m0 0h40v30l-3 12-8 9-9 4-4 1h-16z",
    fill: "#201D1F"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(880)",
    d: "m0 0h56v20h-56z",
    fill: "#FEFEFE"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1335,869)",
    d: "m0 0h1v47h-8v-34l4-10z",
    fill: "#201D1F"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1335,253)",
    d: "m0 0h1v47h-8v-34l4-10z",
    fill: "#201D1F"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1335,1485)",
    d: "m0 0h1v35h-8v-22l4-10z",
    fill: "#201D1F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClassy);
export default __webpack_public_path__ + "static/media/classy.62e8915693ab8618687ce0aea5a1baac.svg";
export { ForwardRef as ReactComponent };